/* eslint-disable simple-import-sort/imports */
/* eslint-disable react/jsx-props-no-spreading */
import { Image } from 'antd';

import { LOCAL_STORAGE } from '../../../constants/local-storage.constant';

interface LogoProps {
  height?: number | false;
  tenant?: boolean;
  light?: boolean;
}

export const Logo = ({ height = 35, tenant = false, light = false }: LogoProps) => {
  const contlabsLogo = '/images/logo-color.0fd3ac33.png';
  const tenantLogo = localStorage.getItem(LOCAL_STORAGE.LOGO);
  // Escritório sem logo cai no logo da Contlabs, como nos e-mails
  const logoUrl = tenant ? tenantLogo || contlabsLogo : contlabsLogo;

  return (
    <Image
      className="logo"
      src={logoUrl}
      alt="Logo da empresa"
      preview={false}
      style={light ? { filter: 'brightness(0) invert(1)' } : undefined}
      {...(height && { height })}
    />
  );
};
